import { Box } from "@mui/material";
import { CustomInput } from "../../../Common/CustomInputs";
import { CustomDropdown } from "../../../Common/CustomDropdown";
import ComplianceDocumentField from "./ComplianceDocumentField";
import { timeZones } from "../../../../assets/data/data";
import {
  SectionHeaderWithMargin,
  FormRow,
  FieldLabel,
  FormFieldBoxRoot,
} from "../../shared/practitionerForm.styles";
import { colors } from "../../../../theme/theme";
import * as C from "../IPHCPractitionerModal.constants";

const COMPLIANCE_ROWS = [
  {
    left: "hipaaCertificate",
    right: { type: "dropdown", fieldName: "timeZone" },
  },
  { left: "backgroundCheck", right: "scopeOfPractice" },
  {
    left: "insuranceCertificates",
    right: { type: "input", fieldName: "zoomLink" },
  },
  { left: "businessAssociateAgreementFile", right: "hipaaAcknowledgement" },
  { left: "clientAgreementAckFile" },
];

const getFileFieldConfig = (fieldName) =>
  C.COMPLIANCE_DOCUMENT_FIELDS.find((f) => f.fieldName === fieldName);

const FormFieldBox = ({ label, children }) => (
  <FormFieldBoxRoot>
    {label && <FieldLabel sx={{ mb: 1 }}>{label}</FieldLabel>}
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        marginTop: "auto",
        marginBottom: "0",
      }}
    >
      {children}
    </Box>
  </FormFieldBoxRoot>
);

const ComplianceDocumentsSection = ({
  submitData,
  updateField,
  handleFileChange,
  handleFileDelete,
}) => {
  const renderFileField = (fieldName) => {
    const config = getFileFieldConfig(fieldName);
    if (!config) return null;
    return (
      <FormFieldBoxRoot key={fieldName}>
        <ComplianceDocumentField
          label={config.label}
          id={config.id}
          file={submitData[fieldName]}
          onChange={(e) => handleFileChange(e, fieldName, config.multiple)}
          onDelete={(file, index) => handleFileDelete(fieldName, index)}
          uploadLabel={config.uploadLabel}
          multiple={config.multiple}
        />
      </FormFieldBoxRoot>
    );
  };

  const renderCell = (cell) => {
    if (typeof cell === "string") {
      return renderFileField(cell);
    }
    if (cell.type === "dropdown") {
      return (
        <FormFieldBox key={cell.fieldName} label={C.LABEL_TIME_ZONE}>
          <CustomDropdown
            value={submitData.timeZone}
            setValue={(value) => updateField("timeZone", value)}
            placeholder={C.PLACEHOLDER_TIME_ZONE}
            data={timeZones}
            noIcon
            color={colors.primary}
            width="100%"
          />
        </FormFieldBox>
      );
    }
    if (cell.type === "input") {
      return (
        <FormFieldBox key={cell.fieldName} label={C.LABEL_ZOOM_LINK}>
          <CustomInput
            value={submitData.zoomLink}
            setValue={(value) => updateField("zoomLink", value)}
            placeholder={C.PLACEHOLDER_ZOOM_LINK}
            label=""
            smallBr
            bR="14px"
            width="100%"
            noIcon
            color={colors.primary}
            mT="auto"
            mB="0"
          />
        </FormFieldBox>
      );
    }
    return null;
  };

  return (
    <>
      <SectionHeaderWithMargin>
        Compliance &amp; Verification Documents
      </SectionHeaderWithMargin>

      {COMPLIANCE_ROWS.map((row, idx) => (
        <FormRow key={idx}>
          {renderCell(row.left)}
          {renderCell(row.right)}
        </FormRow>
      ))}
    </>
  );
};

export default ComplianceDocumentsSection;
